__turbopack_context__.v({
  "helios-choice": "_1JPUaG_helios-choice",
  "helios-choice--card": "_1JPUaG_helios-choice--card",
  "helios-choice--list": "_1JPUaG_helios-choice--list",
  "helios-choice-group": "_1JPUaG_helios-choice-group",
  "helios-choice-group__error": "_1JPUaG_helios-choice-group__error",
  "helios-choice-group__error-icon": "_1JPUaG_helios-choice-group__error-icon",
  "helios-choice-group__legend": "_1JPUaG_helios-choice-group__legend",
  "helios-choice-group__legend--hidden": "_1JPUaG_helios-choice-group__legend--hidden",
  "helios-choice-group__legend--required": "_1JPUaG_helios-choice-group__legend--required",
  "helios-choice-group__options": "_1JPUaG_helios-choice-group__options",
  "helios-choice-group__options--columns-2": "_1JPUaG_helios-choice-group__options--columns-2",
  "helios-choice-group__options--list": "_1JPUaG_helios-choice-group__options--list",
  "helios-choice__description": "_1JPUaG_helios-choice__description",
  "helios-choice__icon": "_1JPUaG_helios-choice__icon",
  "helios-choice__input": "_1JPUaG_helios-choice__input",
  "helios-choice__text": "_1JPUaG_helios-choice__text",
});
